const texte = (valeur) => String(valeur ?? "").trim();
export const FILTRES_CAMPAGNES = ["TOUTES", "EN_PREPARATION", "OUVERTES", "A_CLOTURER", "FERMEES"];
export const PERIODES_CAMPAGNES = [3, 6, 12, 24, "TOUTES"];
export const ARCHIVAGES_CAMPAGNES = ["ACTIVES", "ARCHIVEES", "TOUTES"];

export function campagneArchivee(campagne) {
  return texte(campagne?.statut).toUpperCase() === "ARCHIVEE";
}

export function etatPilotageCampagne(campagne, maintenant = new Date()) {
  const statut = texte(campagne?.statut).toUpperCase();
  const force = texte(campagne?.statut_force || "AUTO").toUpperCase();
  const instant = maintenant instanceof Date ? maintenant.getTime() : new Date(maintenant).getTime();
  const ouverture = new Date(campagne?.ouverture_at).getTime();
  const fermeture = new Date(campagne?.fermeture_at).getTime();
  if (["FERMEE", "ARCHIVEE"].includes(statut)) return "FERMEES";
  if (Number.isFinite(fermeture) && instant > fermeture) return "A_CLOTURER";
  const periodeActive = (!Number.isFinite(ouverture) || instant >= ouverture) && (!Number.isFinite(fermeture) || instant <= fermeture);
  if (force === "EN_LIGNE" || (force !== "HORS_LIGNE" && periodeActive && ["PROGRAMMEE", "OUVERTE"].includes(statut))) return "OUVERTES";
  return "EN_PREPARATION";
}

export function compterCampagnes(campagnes = [], maintenant = new Date()) {
  const actives = campagnes.filter((campagne) => !campagneArchivee(campagne));
  const compteurs = { TOUTES: actives.length, EN_PREPARATION: 0, OUVERTES: 0, A_CLOTURER: 0, FERMEES: 0 };
  actives.forEach((campagne) => { compteurs[etatPilotageCampagne(campagne, maintenant)] += 1; });
  return compteurs;
}

function dansPeriodeOuverture(campagne, periode, maintenant) {
  if (periode === "TOUTES") return true;
  const mois = Number(periode);
  const ouverture = new Date(campagne?.ouverture_at).getTime();
  if (!Number.isFinite(ouverture) || !PERIODES_CAMPAGNES.includes(mois)) return false;
  const reference = maintenant instanceof Date ? new Date(maintenant) : new Date(maintenant);
  if (!Number.isFinite(reference.getTime())) return false;
  const limite = new Date(reference);
  limite.setMonth(limite.getMonth() - mois);
  return ouverture >= limite.getTime();
}

export function trierCampagnesParOuverture(campagnes = []) {
  return [...campagnes].sort((a, b) => {
    const aDate = new Date(a?.ouverture_at).getTime();
    const bDate = new Date(b?.ouverture_at).getTime();
    if (!Number.isFinite(aDate) && !Number.isFinite(bDate)) return 0;
    if (!Number.isFinite(aDate)) return 1;
    if (!Number.isFinite(bDate)) return -1;
    return bDate - aDate;
  });
}

export function filtrerCampagnes(campagnes = [], clubs = [], options = {}) {
  const {
    etat = "TOUTES", statut = "TOUTES", recherche = "", sport = "TOUS", commercial = "TOUS",
    periode = 12, archivage = "ACTIVES", maintenant = new Date()
  } = options;
  const terme = texte(recherche).toLocaleLowerCase("fr");
  const clubParId = new Map(clubs.map((club) => [String(club.id || club.identifiant), club]));
  return trierCampagnesParOuverture(campagnes.filter((campagne) => {
    const club = clubParId.get(String(campagne.club_id));
    const etatCampagne = etatPilotageCampagne(campagne, maintenant);
    const archivee = campagneArchivee(campagne);
    if (archivage === "ACTIVES" && archivee) return false;
    if (archivage === "ARCHIVEES" && !archivee) return false;
    if (!dansPeriodeOuverture(campagne, periode, maintenant)) return false;
    if (etat !== "TOUTES" && etatCampagne !== etat) return false;
    if (statut !== "TOUTES" && etatCampagne !== statut) return false;
    if (sport !== "TOUS" && texte(club?.sport || club?.sports || club?.activite || "Autre") !== sport) return false;
    if (commercial !== "TOUS" && texte(campagne.commercial_id) !== commercial) return false;
    if (terme && ![club?.nom, campagne.nom].some((valeur) => texte(valeur).toLocaleLowerCase("fr").includes(terme))) return false;
    return true;
  }));
}
